import React from 'react';
import { ArrowLeft, Target, Eye, BookOpen, Users, Award } from 'lucide-react';
import { Link } from 'react-router-dom';

const Antecedentes = () => {
    return (
        <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
            {/* Header */}
            <div className="bg-gradient-to-r from-[#0b742f] to-[#085a24] text-white py-16">
                <div className="max-w-7xl mx-auto px-6">
                    <Link
                        to="/maestria"
                        className="inline-flex items-center gap-2 text-green-200 hover:text-white mb-6 transition-colors duration-300"
                    >
                        <ArrowLeft className="w-5 h-5" />
                        Volver a Maestría
                    </Link>
                    <div className="flex items-center gap-4">
                        <div className="bg-white/10 backdrop-blur-sm p-4 rounded-xl">
                            <BookOpen className="w-12 h-12" />
                        </div>
                        <div>
                            <h1 className="text-4xl md:text-5xl font-bold mb-2">Antecedentes</h1>
                            <p className="text-xl text-green-100">
                                Bienvenido a CENID
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-6 py-16">
                {/* Bienvenido a CENID */}
                <section className="mb-16">
                    <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
                        <div className="flex items-center gap-3 mb-8">
                            <BookOpen className="w-8 h-8 text-[#0b742f]" />
                            <h2 className="text-3xl font-bold text-gray-900">Bienvenido a CENID</h2>
                        </div>
                        <div className="prose prose-lg max-w-none text-gray-700">
                            <p className="text-lg leading-relaxed mb-6">
                                El Centro de Estudios e Investigaciones para el Desarrollo Docente CENID, crea
                                una oferta académica en modalidad virtual de maestrías y doctorados surgiendo
                                como respuesta a la evidente necesidad, que presenta la educación de lograr una
                                vinculación rápida y planificada adoptando métodos de enseñanza-aprendizaje,
                                mediante modernas tecnologías de información y comunicación. De paso, se abordará la
                                problemática de la brecha educacional existente en nuestro país, en el ámbito del
                                perfeccionamiento permanente de profesionales.
                            </p>
                            <p className="text-lg leading-relaxed mb-8">
                                Poner al servicio de la Educación Superior las tecnologías educativas y el
                                conocimiento para hacer un uso apropiado de ellas, son las metas que en el CENID se
                                impone con profundidad, para unir a México a la corriente mundial que identifica
                                en estos medios una poderosa, eficaz y eficiente herramienta educativa.
                            </p>
                        </div>

                        <div className="bg-green-50 rounded-lg p-6 mt-8">
                            <h3 className="text-xl font-bold text-[#0b742f] mb-4">El CENID lidera proyectos en los que la tecnología permite:</h3>
                            <ul className="space-y-3">
                                <li className="flex items-start gap-3">
                                    <div className="bg-[#0b742f] text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                                        <span className="text-sm font-bold">•</span>
                                    </div>
                                    <span className="text-gray-700">
                                        Acceder al conocimiento académico sin necesidad de ingresar físicamente a un
                                        campus (la distancia ya no es excusa)
                                    </span>
                                </li>
                                <li className="flex items-start gap-3">
                                    <div className="bg-[#0b742f] text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                                        <span className="text-sm font-bold">•</span>
                                    </div>
                                    <span className="text-gray-700">
                                        Mejorar la eficacia y eficiencia de los procesos de aprendizaje
                                    </span>
                                </li>
                                <li className="flex items-start gap-3">
                                    <div className="bg-[#0b742f] text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                                        <span className="text-sm font-bold">•</span>
                                    </div>
                                    <span className="text-gray-700">
                                        Flexibilizar los modelos de aprendizaje
                                    </span>
                                </li>
                                <li className="flex items-start gap-3">
                                    <div className="bg-[#0b742f] text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                                        <span className="text-sm font-bold">•</span>
                                    </div>
                                    <span className="text-gray-700">
                                        Compartir la cultura, la experiencia y el conocimiento que se genera al interior
                                        de las universidades
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </section>

                {/* Misión */}
                <section className="mb-16">
                    <div className="bg-gradient-to-br from-[#0b742f] to-[#085a24] text-white rounded-2xl shadow-xl p-8 md:p-12">
                        <div className="flex items-center gap-3 mb-8">
                            <Target className="w-10 h-10 text-[#e87729]" />
                            <h2 className="text-3xl font-bold">Misión</h2>
                        </div>
                        <p className="text-lg leading-relaxed text-white/95">
                            Contribuir a la educación para todos a través de la modalidad abierta y a
                            distancia, mediante la investigación, la acción pedagógica, la proyección social y las
                            innovaciones metodológicas y didácticas, con la utilización de las tecnologías
                            de la información y de las comunicaciones, para fomentar y acompañar el
                            aprendizaje autónomo, generador de cultura y espíritu emprendedor que en el marco de la
                            sociedad global y del conocimiento propicie el desarrollo económico, social y
                            humano sostenible de las comunidades locales, regionales y globales con calidad,
                            eficiencia y equidad social.
                        </p>
                    </div>
                </section>

                {/* Visión */}
                <section className="mb-16">
                    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl shadow-xl p-8 md:p-12 border border-blue-100">
                        <div className="flex items-center gap-3 mb-8">
                            <Eye className="w-10 h-10 text-blue-600" />
                            <h2 className="text-3xl font-bold text-gray-900">Visión</h2>
                        </div>
                        <p className="text-lg leading-relaxed text-gray-700">
                            Se proyecta como una organización líder en Educación Abierta y a Distancia,
                            reconocida a nivel nacional e internacional por la calidad innovadora y pertinencia
                            de sus ofertas y servicios educativos y por su compromiso y aporte de su
                            comunidad académica al desarrollo humano sostenible, de las comunidades locales y
                            globales.
                        </p>
                    </div>
                </section>

                {/* Objetivos */}
                <section>
                    <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border-l-4 border-[#e87729]">
                        <div className="flex items-center gap-3 mb-8">
                            <Award className="w-10 h-10 text-[#e87729]" />
                            <h2 className="text-3xl font-bold text-gray-900">Objetivos</h2>
                        </div>

                        <div className="space-y-8">
                            <div className="bg-gray-50 rounded-lg p-6">
                                <h3 className="text-xl font-bold text-[#0b742f] mb-4">Educación abierta y permanente</h3>
                                <p className="text-gray-700 leading-relaxed">
                                    Formular políticas, planes, proyectos, estrategias y acciones de educación
                                    abierta permanente, que faciliten el diseño y realización de programas de formación
                                    de adultos en todos los niveles y ciclos educativos, competencias laborales,
                                    desarrollo comunitario y atención de poblaciones vulnerables, mediante el uso
                                    intensivo de las tecnologías de la información y comunicación.
                                </p>
                            </div>

                            <div className="bg-gray-50 rounded-lg p-6">
                                <h3 className="text-xl font-bold text-[#0b742f] mb-4">Investigación y desarrollo</h3>
                                <p className="text-gray-700 leading-relaxed">
                                    Fomentar la cultura investigativa y el espíritu emprendedor, para el diseño y
                                    desarrollo de procesos de innovación social, tecnológica, productiva y
                                    científica, que contribuyan a dar soluciones acordes con las necesidades y posibilidades
                                    de los diferentes contextos regionales y socioculturales.
                                </p>
                            </div>

                            <div className="bg-gray-50 rounded-lg p-6">
                                <h3 className="text-xl font-bold text-[#0b742f] mb-4">Redes académicas</h3>
                                <p className="text-gray-700 leading-relaxed">
                                    Promover la construcción de redes apoyadas en tecnologías, para consolidar las
                                    comunidades académicas de docentes, tutores, estudiantes y egresados, que
                                    promuevan los principios y las prácticas de la identidad del CENID y generen nuevas
                                    formas de asociación, convivencia y participación comunitaria.
                                </p>
                            </div>

                            <div className="bg-gray-50 rounded-lg p-6">
                                <h3 className="text-xl font-bold text-[#0b742f] mb-4">Liderazgo en educación abierta y a distancia</h3>
                                <p className="text-gray-700 leading-relaxed">
                                    Fomentar políticas para el desarrollo y sostenibilidad de la modalidad de
                                    educación abierta y a distancia, con la utilización de tecnologías telemáticas y
                                    virtuales, en el contexto de la sociedad del conocimiento, en los ámbitos local,
                                    regional, nacional y global.
                                </p>
                            </div>

                            <div className="bg-gray-50 rounded-lg p-6">
                                <h3 className="text-xl font-bold text-[#0b742f] mb-4">Sostenibilidad holística</h3>
                                <p className="text-gray-700 leading-relaxed">
                                    Diseñar alternativas para la diversificación de fuentes de financiación a
                                    través de la oferta de programas, de prestación de servicios, asesorías, consultorías
                                    y proyectos especiales, que promuevan la gestión de la universidad y coadyuven
                                    a su impacto social y sostenibilidad financiera.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Antecedentes;